<template>
	<Layouts>
		<!-- ここに画面のタイトルを入力する -->
		<template v-slot:title>
			<div class="contents_header">
				<Title
					:title="'KIZUNA 顧客'"
					:subTitle="'編集'"
					:text="''"
					:icon="'fa-address-book'"
				/>
			</div>
		</template>
		<!-- ここにコンテンツを入力する -->
		<template v-slot:contents>
			<div class="mb-[70px] mt-12 flex items-start">
				<div class="contentBox mr-12 w-full">
					<div class="text-[18px]">基本情報</div>

					<!-- /* ---------------------------------------------------------------------------
						タイプ
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6">
						<CheckboxArray
							v-model="formData.type"
							:checkbox-item="salesEnums.typeEnum"
							:name="'type'"
							:title="'タイプ'"
							:required="true"
							:disabled="false"
							:error-text="''"
						/>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						監理種別,区分
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 監理種別 -->
						<div>
							<RadioForm
								v-model="formData.management_type"
								:title="'監理種別'"
								:name="'management_type'"
								:required="false"
								:radio-item="salesEnums.mgmt_type"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>

						<!-- 区分 -->
						<div class="ml-4">
							<RadioForm
								v-model="formData.category"
								:title="'区分'"
								:name="'category'"
								:required="false"
								:radio-item="salesEnums.category"
								:disabled="typeFlag == 1 ? true : false"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						企業名,法人番号
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 企業名 -->
						<div class="w-[70%]">
							<InputForm
								v-model="formData.company_name"
								:type="'text'"
								:title="'企業名'"
								:text="''"
								:required="true"
								:disabled="false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>

						<!-- 法人番号 -->
						<div class="ml-4 w-[30%]">
							<InputForm
								v-model="formData.corporate_number"
								:type="'text'"
								:title="'法人番号'"
								:text="''"
								:required="false"
								:disabled="false"
								:maxlength="13"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						郵便番号,住所
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6">
						<AddressForm
							v-model:zip1="formData.zip1"
							v-model:zip2="formData.zip2"
							v-model:address="formData.address"
							:kizuna-type="3"
							:title="{ zip: '郵便番号', address: '住所' }"
							:form-class="'w-full'"
							:required="{
								zip: false,
								address: false
							}"
							:disabled="false"
							:error-text="{
								zip1: errors.zip1,
								zip2: errors.zip2,
								address: errors.address
							}"
						/>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						電話番号,FAX,代表者名
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 電話番号 -->
						<div class="w-full">
							<InputForm
								v-model="formData.tel"
								:type="'text'"
								:title="'電話番号'"
								:text="''"
								:required="false"
								:disabled="false"
								:maxlength="13"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>
						<!-- FAX -->
						<div class="ml-4 w-full">
							<InputForm
								v-model="formData.fax"
								:type="'text'"
								:title="'FAX'"
								:text="''"
								:required="false"
								:disabled="false"
								:maxlength="13"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>
						<!-- 代表者名 -->
						<div class="ml-4 w-full">
							<InputForm
								v-model="formData.name"
								:type="'text'"
								:title="'代表者名'"
								:text="''"
								:required="false"
								:disabled="false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						担当者名（技能）,担当者名（特定）
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 担当者名（技能） -->
						<div class="w-full">
							<InputForm
								v-model="formData.skill_staff_name"
								:type="'text'"
								:title="'担当者名（技能）'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 担当者名（特定） -->
						<div class="ml-4 w-full">
							<InputForm
								v-model="formData.spec_skill_staff_name"
								:type="'text'"
								:title="'担当者名（特定）'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
						<div class="ml-4 w-full"></div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						企業URL
					---------------------------------------------------------------------------- */ -->
					<!-- 企業URL -->
					<div class="mt-6">
						<InputForm
							v-model="formData.company_url"
							:type="'text'"
							:title="'企業URL'"
							:text="''"
							:required="false"
							:disabled="false"
							:maxlength="255"
							:form-class="'w-full'"
							:error-text="''"
							:placeholder="'https://'"
							:kizuna-type="3"
						/>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						メールアドレス（一般監理）,メールアドレス（特定監理）
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- メールアドレス（一般監理） -->
						<div class="w-full">
							<InputTagForm
								v-model="formData.skill_staff_email"
								:type="'text'"
								:title="'メールアドレス（技能）'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>

						<!-- メールアドレス（特定監理） -->
						<div class="ml-4 w-full">
							<InputTagForm
								v-model="formData.spec_skill_staff_email"
								:type="'text'"
								:title="'メールアドレス（特定監理）'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						許可日,許可期限,受入れ国
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 許可日 -->
						<div class="w-full">
							<DatePicker
								v-model="formData.approval_date"
								:title="'許可日'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 許可期限 -->
						<div class="ml-4 w-full">
							<DatePicker
								v-model="formData.approval_deadline"
								:title="'許可期限'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 受入れ国 -->
						<div class="ml-4 w-full">
							<MultiselectForm
								v-model="formData.receiving_country"
								:select-type="''"
								:enum="salesEnums.country"
								:title="'受入れ国'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						許可日,許可期限,受入れ国
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 介護職の有無 -->
						<div class="w-full">
							<InputForm
								v-model="formData.caregiver_job_availability"
								:type="'text'"
								:title="'介護職の有無'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 事業の有無 -->
						<div class="ml-4 w-full">
							<RadioForm
								v-model="formData.business_availability"
								:title="'事業の有無'"
								:name="'business_availability'"
								:required="false"
								:radio-item="salesEnums.isOrIsnt"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 状態 -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.status"
								:select-type="''"
								:enum="salesEnums.status"
								:title="'状態'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						架電結果,見込み,見込みなし
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 架電結果 -->
						<div class="w-full">
							<SelectForm
								v-model="formData.call_result"
								:select-type="''"
								:enum="salesEnums.call_result"
								:title="'架電結果'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 見込み -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.estimate"
								:select-type="''"
								:enum="salesEnums.estimate"
								:title="'見込み'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 見込みなし -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.no_estimate"
								:select-type="''"
								:enum="salesEnums.no_estimate"
								:title="'見込みなし'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						商談後状況,管理方法,管理方法（その他）
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 商談後状況 -->
						<div class="w-full">
							<SelectForm
								v-model="formData.post_meeting_status"
								:select-type="''"
								:enum="salesEnums.post_meeting_status"
								:title="'商談後状況'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 管理方法 -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.management_method"
								:select-type="''"
								:enum="salesEnums.management_method"
								:title="'管理方法'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 管理方法（その他） -->
						<div class="ml-4 w-full">
							<InputForm
								v-if="typeFlag != 2"
								v-model="formData.other_management_method"
								:type="'text'"
								:title="'管理方法（その他）'"
								:text="''"
								:required="false"
								:disabled="formData.management_method != 5 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:placeholder="''"
								:kizuna-type="1"
							/>
							<InputForm
								v-else
								v-model="formData.other_management_method"
								:type="'text'"
								:title="'管理方法（その他）'"
								:text="''"
								:required="false"
								:disabled="true"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:placeholder="''"
								:kizuna-type="1"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						特定監理有無,商談月,申込月
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 特定監理有無 -->
						<div class="w-full">
							<RadioForm
								v-model="formData.has_specific_skill"
								:title="'特定監理有無'"
								:name="'has_specific_skill'"
								:required="false"
								:radio-item="salesEnums.isOrIsnt"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 商談月 -->
						<div class="ml-4 w-full">
							<MonthPicker
								v-model="formData.meeting_month"
								:title="'商談月'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 申込月 -->
						<div class="ml-4 w-full">
							<MonthPicker
								v-model="formData.application_month"
								:title="'申込月'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						利用状況,解約理由,資料ダウンロードの有無
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 利用状況 -->
						<div class="w-full">
							<SelectForm
								v-model="formData.usage_status"
								:select-type="''"
								:enum="salesEnums.usage_status"
								:title="'利用状況'"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
						<!-- 解約理由 -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.cancellation_reason"
								:select-type="''"
								:enum="salesEnums.cancellation_reason"
								:title="'解約理由'"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
						<!-- 資料ダウンロードの有無 -->
						<div class="ml-4 w-full">
							<RadioForm
								v-model="formData.download_document"
								:title="'資料ダウンロードの有無'"
								:name="'download_document'"
								:required="false"
								:radio-item="salesEnums.isOrIsnt"
								:disabled="typeFlag == 1 ? true : false"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
					</div>
					<div class="mt-6 flex">
						<!-- 資料ダウンロードの月 -->
						<div class="w-full">
							<MonthPicker
								v-model="formData.download_month"
								:title="'資料ダウンロード月'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
						<div class="ml-4 w-full"></div>
						<div class="ml-4 w-full"></div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						備考
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6">
						<TextareaForm
							v-model="formData.remarks"
							:title="'備考'"
							:required="false"
							:disabled="false"
							:form-class="'w-full'"
							:maxlength="1000"
							:error-text="''"
							:placeholder="''"
							:kizuna-type="3"
						/>
					</div>
				</div>

				<div class="h-full w-full">
					<MoleSupportLogCreateButton
						@support-log-create-modal-open="supportLogCreateModalOpen"
						class="mb-8"
					/>

					<OrgSupportLogList
						v-for="(item, index) in supportLogList"
						:support-log-data="item"
						:key="item.id"
						@support-log-edit="supportLogEdit"
						@support-log-delete-modal-open="supportLogDeleteModalOpen"
					/>
				</div>
			</div>
			<div class="buttonField flex items-center justify-between">
				<div v-if="!prevDisabled" class="pageButton" @click="pageMove('prev')">
					<i class="fa-solid fa-arrow-left fa-fw fa-lg ml-1" />
				</div>
				<div v-else class="pageButton disabled">
					<Tooltip
						:description="
							'page' + currentPage.page + 'の先頭のため、遷移できません。'
						"
					>
						<i class="fa-solid fa-arrow-left fa-fw fa-lg ml-1" />
					</Tooltip>
				</div>

				<div class="flex">
					<Button
						:button-type="'button'"
						:button-class="'button-gray'"
						:button-icon="'fa-arrow-left'"
						:button-text="'戻る'"
						@click="back"
					/>

					<Button
						:button-type="'button'"
						:button-class="'button-red ml-12'"
						:button-icon="'fa-pen'"
						:button-text="'更新'"
						@click="update"
					/>

					<button class="trashButton ml-12" @click="companiesDeleteModalOpen">
						<i class="fa-solid fa-trash fa-fw fa-lg ml-1" />
					</button>
				</div>
				<div v-if="!nextDisabled" class="pageButton" @click="pageMove('next')">
					<i class="fa-solid fa-arrow-right fa-fw fa-lg ml-1" />
				</div>
				<div v-else class="pageButton disabled">
					<Tooltip
						:description="
							'page' + currentPage.page + 'の最後のため、遷移できません。'
						"
					>
						<i class="fa-solid fa-arrow-right fa-fw fa-lg ml-1" />
					</Tooltip>
				</div>
			</div>
		</template>
	</Layouts>

	<MoleSupportLogRegistModal
		:is-modal="createSupportLogModalFlag"
		:form-data="supportLogData.content"
		:title="supportLogData.id != '' ? '応対履歴の編集' : '応対履歴の登録'"
		:button-text="supportLogData.id != '' ? '更新' : '登録'"
		:error="supportError"
		@store="supportLogStore"
		@modal-close="modalCose"
	/>

	<MoleCompaniesDeleteModal
		:is-modal="deleteCompaniesModalFlag"
		:title="'顧客情報の削除'"
		@data-delete="companiesDelete"
		@modal-close="modalCose"
	>
		<template v-slot:contents>
			<p class="font-normal">
				選択した顧客情報を削除します。<br />
				一度削除しますと<b class="text-color-red2">元に戻すことはできません</b
				>。
			</p>
		</template>
	</MoleCompaniesDeleteModal>

	<MoleSupportLogDeleteModal
		:is-modal="deleteSupportLogModalFlag"
		:title="'応対履歴の削除'"
		@data-delete="supportLogDelete"
		@modal-close="modalCose"
	>
		<template v-slot:contents>
			<p class="font-normal">
				選択した応対履歴を削除します。<br />
				一度削除しますと<b class="text-color-red2">元に戻すことはできません</b
				>。
			</p>
		</template>
	</MoleSupportLogDeleteModal>
</template>
<script setup>
// その他
import Button from "@/components/atoms/Button.vue";
import Title from "@/components/atoms/Title.vue";
import Tooltip from "@/components/atoms/Tooltip.vue";
import Layouts from "@/components/layouts/Layouts.vue";
import AddressForm from "@/components/molecules/form/AddressForm.vue";
import CheckboxArray from "@/components/molecules/form/CheckboxArray.vue";
import DatePicker from "@/components/molecules/form/DatePicker.vue";
import InputForm from "@/components/molecules/form/InputForm.vue";
import InputTagForm from "@/components/molecules/form/InputTagForm.vue";
import MonthPicker from "@/components/molecules/form/MonthPicker.vue";
import MultiselectForm from "@/components/molecules/form/MultiselectForm.vue";
import RadioForm from "@/components/molecules/form/RadioForm.vue";
import SelectForm from "@/components/molecules/form/SelectForm.vue";
import TextareaForm from "@/components/molecules/form/TextareaForm.vue";
import {
	default as MoleCompaniesDeleteModal,
	default as MoleSupportLogDeleteModal
} from "@/components/molecules/modal/MoleDeleteModal.vue";
import MoleSupportLogCreateButton from "@/components/molecules/sales/MoleSupportLogCreateButton.vue";
import MoleSupportLogRegistModal from "@/components/molecules/sales/MoleSupportLogRegistModal.vue";
import OrgSupportLogList from "@/components/organisms/sales/OrgSupportLogList.vue";
import { format } from "date-fns";
import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
//store
import { useAuthStore } from "@/stores/AuthStore";
import { usePartsStore } from "@/stores/PartsStore";
// utils
import * as salesEnums from "@/enums/SalesEnums.js";
import toaster from "@/utils/Toaster.js";
// stubs
import * as salesStubs from "@/stubs/Sales.js";
// api
import FunctionApi from "@/api/FunctionApi.js";

const authStore = useAuthStore();
const partsStore = usePartsStore();
const functionApi = new FunctionApi();
/* ---------------------------------------------------------------------------
	router
---------------------------------------------------------------------------- */
const router = useRouter();
const route = useRoute();
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { alert } = toaster();
/* ---------------------------------------------------------------------------
	data
---------------------------------------------------------------------------- */
const formData = ref({ ...salesStubs.form });
const pageList = ref([]);
const supportLogList = ref([]);
const supportLogData = ref({
	company_id: "",
	support_log_id: "",
	content: ""
});
const typeFlag = ref(null);
const createSupportLogModalFlag = ref(false);
const deleteSupportLogModalFlag = ref(false);
const deleteCompaniesModalFlag = ref(false);
const supportLogDeleteId = ref(null);
const errors = ref([]);
const supportError = ref("");
const skipWatch = ref(false);
const prevDisabled = ref(false);
const nextDisabled = ref(false);
const currentPage = ref(0);

/* ---------------------------------------------------------------------------
タイプを切り替えた時のイベント
---------------------------------------------------------------------------- */
watch(
	() => formData.value.type,
	val => {
		// skipWatch が true の場合、watch を無視
		if (skipWatch.value) return;

		if (val === null) {
			typeFlag.value = null;
		} else if (Array.isArray(val)) {
			const has1 = val.includes("1");
			const has2 = val.includes("2");

			if (has1 && has2) {
				typeFlag.value = 3;
			} else if (has1) {
				typeFlag.value = 1;
				formatClear(2);
			} else if (has2) {
				typeFlag.value = 2;
				formatClear(1);
			} else {
				typeFlag.value = null;
			}
		} else {
			// 必要に応じてエラーハンドリング
			typeFlag.value = null;
		}
	}
);
/* ---------------------------------------------------------------------------
	ウォッチャー（初期値設定）
---------------------------------------------------------------------------- */
function formatClear(value) {
	const format = value == 1 ? salesStubs.formatClear2 : salesStubs.formatClear1;

	for (let key in format) {
		if (formData.value.hasOwnProperty(key)) {
			formData.value[key] = format[key];
		}
	}
}

/* ---------------------------------------------------------------------------
顧客情報api
---------------------------------------------------------------------------- */
// 顧客詳細
async function companiesShow() {
	skipWatch.value = true;
	await functionApi.company.show(formData.value.id).then(res => {
		formData.value = res.data;

		formData.value.skill_staff_email = formData.value.skill_staff_email ?? [];
		formData.value.spec_skill_staff_email =
			formData.value.spec_skill_staff_email ?? [];
		formData.value.receiving_country = formData.value.receiving_country ?? [];
	});

	if (formData.value.type == 1) {
		typeFlag.value = 1;
		formatClear(2);
	} else if (formData.value.type == 2) {
		typeFlag.value = 2;
		formatClear(1);
	} else if (formData.value.type == 3) {
		typeFlag.value = 3;
	} else {
		typeFlag.value = null;
	}

	skipWatch.value = false;
}
// 顧客更新
async function update() {
	if (formData.value.approval_date != "") {
		formData.value.approval_date = format(
			formData.value.approval_date,
			"yyyy-MM-dd"
		);
	}
	if (formData.value.approval_deadline != "") {
		formData.value.approval_deadline = format(
			formData.value.approval_deadline,
			"yyyy-MM-dd"
		);
	}

	partsStore.detailLoader = true;

	await functionApi.company
		.update(formData.value.id, formData.value)
		.then(res => {
			partsStore.detailLoader = false;
			// 成功
			if (res.result) {
				alert("update");
				// 失敗
			} else {
				errors.value = res.errors;
				alert("error_update");
			}
		});
}

// 顧客削除
async function companiesDelete() {
	partsStore.detailLoader = true;
	await functionApi.company.destroy(formData.value.id).then(res => {
		partsStore.detailLoader = false;
		// 成功
		if (res.result) {
			alert("delete");
			router.push("/sales/companies");
			// 失敗
		} else {
			errors.value = res.errors;
			alert("error_delete");
		}
	});
}
/* ---------------------------------------------------------------------------
応対履歴api
---------------------------------------------------------------------------- */
// 応対履歴一覧取得
async function supportLogListShow() {
	await functionApi.supportLog.list(formData.value.id).then(res => {
		supportLogList.value = res.data;
	});
}
// 応対履歴　登録・更新
async function supportLogStore(value) {
	supportLogData.value.content = value;
	partsStore.detailLoader = true;
	await functionApi.supportLog
		.store(supportLogData.value.support_log_id, supportLogData.value)
		.then(res => {
			partsStore.detailLoader = false;
			// 成功
			if (res.result) {
				alert("store");
				supportLogListShow();
				// 失敗
			} else {
				supportError.value = res.errors.content;
				alert("error_store");
				createSupportLogModalFlag.value = true;
			}
		});
}
// 応対履歴の削除
async function supportLogDelete() {
	partsStore.detailLoader = true;
	await functionApi.supportLog.destroy(supportLogDeleteId.value).then(res => {
		partsStore.detailLoader = false;
		// 成功
		if (res.result) {
			alert("delete");
			supportLogListShow();
			// 失敗
		} else {
			errors.value = res.errors;
			alert("error_delete");
		}
	});
}

/* ---------------------------------------------------------------------------
modal
---------------------------------------------------------------------------- */
function supportLogEdit(data) {
	createSupportLogModalFlag.value = true;

	supportLogData.value.company_id = data.company_id;
	supportLogData.value.support_log_id = data.id;
	supportLogData.value.content = data.content;
}

function supportLogCreateModalOpen(data) {
	supportLogData.value.support_log_id = "";
	supportLogData.value.content = "";
	createSupportLogModalFlag.value = true;
}

// 応対履歴の削除モーダル
async function supportLogDeleteModalOpen(supportLog) {
	supportLogDeleteId.value = supportLog.id;
	deleteSupportLogModalFlag.value = true;
}

// 顧客の削除モーダル
async function companiesDeleteModalOpen() {
	deleteCompaniesModalFlag.value = true;
}

function modalCose(value) {
	createSupportLogModalFlag.value = false;
	deleteSupportLogModalFlag.value = false;
	deleteCompaniesModalFlag.value = false;
}
/* ---------------------------------------------------------------------------
戻る
---------------------------------------------------------------------------- */
function back() {
	router.push("/sales/companies");
}

// ページ遷移
async function pageMove(flag) {
	// 現在のページのインデックスを取得
	const currentIndex = pageList.value.findIndex(
		page => page.id === formData.value.id
	);

	// 該当するIDが存在しない場合
	if (currentIndex == -1 && flag == "prev") {
		prevDisabled.value = true;
		return;
	}
	// 該当するIDが存在しない場合
	if (currentIndex == -1 && flag == "next") {
		nextDisabled.value = true;
		return;
	}

	// 次のページのIDを取得
	let nextIndex;
	if (flag === "prev") {
		// 前のページ（インデックスが減る）
		nextIndex = currentIndex > 0 ? currentIndex - 1 : currentIndex;
	} else if (flag === "next") {
		// 次のページ（インデックスが増える）
		nextIndex =
			currentIndex < pageList.value.length - 1
				? currentIndex + 1
				: currentIndex;
	}

	// 遷移先のページID
	const nextPageId = pageList.value[nextIndex].id;

	// ルーターで遷移
	router.push(`/sales/companies/${nextPageId}/edit`);

	partsStore.detailLoader = true;

	setTimeout(() => {
		location.reload();
	}, 200);
}

// 前後のボタンの有効/無効を設定
function checkNavigationState() {
	// 現在のIDのインデックスを取得
	const currentIndex = pageList.value.findIndex(
		page => page.id === formData.value.id
	);

	// 該当するIDがない場合は両方を無効化
	if (currentIndex === -1) {
		prevDisabled.value = true;
		nextDisabled.value = true;
		return;
	}

	// 前後の状態をチェックしてボタンの有効/無効を設定
	// 最初のページならprev無効
	prevDisabled.value = currentIndex === 0;
	// 最後のページならnext無効
	nextDisabled.value = currentIndex === pageList.value.length - 1;
}

onMounted(async () => {
	formData.value.id = route.params.id;
	supportLogData.value.company_id = route.params.id;

	if (JSON.parse(sessionStorage.getItem("saveList"))) {
		pageList.value = JSON.parse(sessionStorage.getItem("saveList")) || [];
	}

	if (JSON.parse(sessionStorage.getItem("searchData"))) {
		currentPage.value = JSON.parse(sessionStorage.getItem("searchData")) || 0;
	}

	await companiesShow();
	await supportLogListShow();

	checkNavigationState();
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.pageButton {
	cursor: pointer;
	border-radius: 60px;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: $bg-gray2;
	color: $color-gray4;
	@include trans(0.3);
	&:hover {
		color: $color-white2;
		background: $bg-blue2;
		@include trans(0.3);
	}
	&.disabled {
		cursor: unset;
		color: $color-gray2;
		background: $bg-gray3;
	}
}
.trashButton {
	border-radius: 60px;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: $bg-gray3;
	color: $color-gray4;
	@include trans(0.3);
	&:hover {
		color: $color-white2;
		background: $bg-red2;
		@include trans(0.3);
	}
}
</style>
